"use client";
import { faAngleRight } from "@fortawesome/pro-solid-svg-icons";

import Button from "@/components/button";
import { ButtonBar } from "@/components/layouts";
import { ButtonGroup } from "@/components/layouts/button-group";
import { useModal } from "@/hooks/use-modal";

import { CreateThreadButton } from "./create-thread-button";

const CommunityButtons = () => {
  const { openModal } = useModal();

  return (
    <ButtonBar>
      <ButtonGroup>
        <CreateThreadButton />
      </ButtonGroup>

      <ButtonGroup align="right">
        <Button href="/community/general/1" icon={faAngleRight}>
          See more
        </Button>
      </ButtonGroup>
    </ButtonBar>
  );
};

export { CommunityButtons };
